__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "root";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@imaginelearning/link-player-api", "1.2.0", function() { return Promise.all([__webpack_require__.e(341), __webpack_require__.e(900), __webpack_require__.e(899)]).then(function() { return function() { return __webpack_require__(4899); }; }); });
			register("@imaginelearning/link-player-auth", "1.2.0", function() { return Promise.all([__webpack_require__.e(957), __webpack_require__.e(900), __webpack_require__.e(590), __webpack_require__.e(323)]).then(function() { return function() { return __webpack_require__(9131); }; }); });
			register("@tanstack/react-query", "5.18.1", function() { return Promise.all([__webpack_require__.e(30), __webpack_require__.e(900)]).then(function() { return function() { return __webpack_require__(3030); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(778), __webpack_require__.e(900)]).then(function() { return function() { return __webpack_require__(9778); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(388).then(function() { return function() { return __webpack_require__(7342); }; }); });
			initExternal(2796);
			initExternal(1178);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};